import { 
  collection,
  query,
  where,
  orderBy,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  doc
} from 'firebase/firestore';
import { db } from './firebase';

export interface RushdTreat {
  id: string;
  productId: string;
  productName: string;
  productImage?: string | null;
  quantity: number;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

const COLLECTION = 'rushdTreats';

export const getAllRushdTreats = async (): Promise<RushdTreat[]> => {
  const treatsRef = collection(db, COLLECTION);
  const q = query(treatsRef, orderBy('createdAt', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docSnap) => {
    const data = docSnap.data();
    return {
      id: docSnap.id,
      productId: data.productId,
      productName: data.productName,
      productImage: data.productImage || null,
      quantity: data.quantity || 1,
      isActive: data.isActive ?? true,
      createdAt: data.createdAt?.toDate?.() || new Date(),
      updatedAt: data.updatedAt?.toDate?.() || new Date(),
    } as RushdTreat;
  });
};

export const getActiveRushdTreats = async (): Promise<RushdTreat[]> => {
  const treatsRef = collection(db, COLLECTION);
  const q = query(treatsRef, where('isActive', '==', true), orderBy('createdAt', 'desc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map((docSnap) => {
    const data = docSnap.data();
    return {
      id: docSnap.id,
      productId: data.productId,
      productName: data.productName,
      productImage: data.productImage || null,
      quantity: data.quantity || 1,
      isActive: data.isActive ?? true,
      createdAt: data.createdAt?.toDate?.() || new Date(),
      updatedAt: data.updatedAt?.toDate?.() || new Date(),
    } as RushdTreat;
  });
};

export const createRushdTreat = async (treat: Omit<RushdTreat, 'id' | 'createdAt' | 'updatedAt'>): Promise<string> => {
  const treatsRef = collection(db, COLLECTION);
  const docRef = await addDoc(treatsRef, {
    ...treat,
    isActive: treat.isActive ?? true,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
  return docRef.id;
};

export const updateRushdTreat = async (id: string, updates: Partial<Omit<RushdTreat, 'id' | 'createdAt' | 'updatedAt'>>): Promise<void> => {
  const treatDoc = doc(db, COLLECTION, id);
  await updateDoc(treatDoc, {
    ...updates,
    updatedAt: serverTimestamp(),
  });
};

export const deleteRushdTreat = async (id: string): Promise<void> => {
  const treatDoc = doc(db, COLLECTION, id);
  await deleteDoc(treatDoc);
};

export const toggleRushdTreat = async (id: string, isActive: boolean): Promise<void> => {
  await updateRushdTreat(id, { isActive });
};
